import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../catalog/config/component.config';
import { NPageHeader } from '../../../layout/page/header/page-header.interface';
import { NCmsBlogComponentImageWithCopy } from '../component/image-with-copy/cms-blog-component-image-with-copy.interface';
import { NCmsBlogComponentImageWithOverlappingCopy } from '../component/image-with-overlapping-copy/cms-blog-component-image-with-overlapping-copy.interface';

export namespace NCmsBlogPost {
    export const typeId = 'blog-post';

    export interface ITypeData
        extends NPageHeader.IVersionConfig,
            NCmsBlogComponentImageWithCopy.IData,
            NCmsBlogComponentImageWithOverlappingCopy.IData,
            ICmsComponentCwvConfig {
        variant?: EPageVariant;
        date?: Date;
        topComponents?: NICmsContentComponent.IData[];
        // old data
        primary_tag?: string;
        show_related: boolean;
        components: NICmsContentComponent.IData[];
        short_description?: string;
    }
}

export enum EPageVariant {
    var_1 = 'var_1',
    var_2 = 'var_2'
}
